"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticDropdown = void 0;
var React = __importStar(require("react"));
var useDropdownOptions_1 = require("../hooks/useDropdownOptions");
var DropdownMenu_1 = require("./DropdownMenu");
var StaticDropdown = function (_a) {
    var initialOption = _a.initialOption, options = _a.options, onSelection = _a.onSelection, width = _a.width, Icon = _a.Icon, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onOptionHoverStart = _a.onOptionHoverStart, onOptionHoverEnd = _a.onOptionHoverEnd, footer = _a.footer, onClick = _a.onClick, props = __rest(_a, ["initialOption", "options", "onSelection", "width", "Icon", "disabled", "onOptionHoverStart", "onOptionHoverEnd", "footer", "onClick"]);
    var _c = (0, useDropdownOptions_1.useDropdownOptions)({ onSelection: onSelection, options: options, initialOption: initialOption }), handleSelection = _c.handleSelection, selected = _c.selected, isOpen = _c.isOpen, toggle = _c.toggle, close = _c.close;
    return (React.createElement(DropdownMenu_1.DropdownMenuWrapper, __assign({ close: close, isOpen: isOpen, toggle: toggle, width: width, Icon: Icon, disabled: disabled, onClick: onClick, selected: selected }, props), isOpen && !disabled && (React.createElement(DropdownMenu_1.StaticDropdownMenu, { options: options, handleSelection: function (option) {
            handleSelection(option);
            close();
        }, onOptionHoverStart: onOptionHoverStart, onOptionHoverEnd: onOptionHoverEnd, footer: footer }))));
};
exports.StaticDropdown = StaticDropdown;
//# sourceMappingURL=StaticDropdown.js.map